module.exports = __webpack_public_path__ + "img/goldlogo.a57f734e.png";